module.exports = __webpack_public_path__ + "img/sanpaolo_background_hero.aee1b376.png";